import propTypes from 'prop-types';
export default window.PropTypes ? window.PropTypes : propTypes;